import React from 'react';
export function Footer() {
  return <footer className="bg-background py-16 px-6 border-t border-border/50" data-id="element-29">
      <div className="max-w-7xl mx-auto" data-id="element-30">
        <div className="flex flex-col md:flex-row justify-between gap-10 md:gap-8" data-id="element-31">
          {/* Left — Company info */}
          <div className="text-center md:text-left" data-id="element-32">
            <h4 className="text-base font-medium text-ink mb-1" data-id="element-33">
              Humble Consulting AB
            </h4>
            <p className="text-xs text-muted/60 mb-3" data-id="element-34">
              En del av{' '}
              <a href="https://www.be-brave.se" target="_blank" rel="noopener noreferrer" className="hover:text-muted transition-colors underline underline-offset-2" data-id="element-35">
                Be Brave
              </a>
            </p>
            <p className="text-xs text-muted/40 font-mono tracking-wide" data-id="element-36">
              Org.nr 556972-5277
            </p>
          </div>

          {/* Right — Contact */}
          <div className="flex flex-col items-center md:items-end gap-2" data-id="element-37">
            <a href="mailto:peter@humble-consulting.se" className="text-muted/60 hover:text-muted transition-colors text-sm" data-id="element-38">
              peter@humble-consulting.se
            </a>
            <a href="tel:+46736580469" className="text-muted/60 hover:text-muted transition-colors text-sm" data-id="element-39">
              +46 73 658 04 69
            </a>
            <a href="https://www.linkedin.com/in/peteralkeryd/" target="_blank" rel="noopener noreferrer" className="text-muted/60 hover:text-muted transition-colors text-sm" data-id="element-40">
              LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-border/30 text-center" data-id="element-41">
          <p className="text-xs text-muted/40" data-id="element-42">
            © {new Date().getFullYear()} Humble Consulting AB
          </p>
        </div>
      </div>
    </footer>;
}